import React, { VFC } from 'react';
import { Col, Row, Visible } from 'react-grid-system';
import styled from 'styled-components';
import { useSettings } from '../../contexts/settingsContext';
import { theme } from '../../utils/theme';
import Spacing from '../atoms/Spacing';
import SvgIcon from '../atoms/SvgIcon';
import Typography from '../atoms/Typography';

interface Props extends React.HTMLProps<HTMLDivElement> {
  message: string;
  variant?: 'warning' | 'error';
}

interface DivStyleProps {
  backgroundcolor: string;
  bordercolor: string;
  radius: string;
}

const StyledRow = styled(Row)<DivStyleProps>`
  border-radius: ${({ radius }) => radius};
  padding: 3.2rem 1.6rem;
  background-color: ${({ backgroundcolor }) => backgroundcolor};
  border: 2px solid ${({ bordercolor }) => bordercolor};
`;

const StyledText = styled(Typography)`
  display: inline;
`;

const Banner: VFC<Props> = ({ message, variant = 'warning', children }) => {
  const { cornerRadius } = useSettings();
  const getBackgroundColor = () => {
    switch (variant) {
      case 'warning':
        return '#FFF8E1';
      default:
        return '#FBE9E7';
    }
  };

  const getBorderColor = () => {
    switch (variant) {
      case 'warning':
        return '#FFE082';
      default:
        return '#FFAB91';
    }
  };

  return (
    <StyledRow
      align="center"
      gutterWidth={16}
      radius={cornerRadius}
      bordercolor={getBorderColor()}
      backgroundcolor={getBackgroundColor()}
    >
      <Col xs={12} sm={12} md="content">
        <SvgIcon icon={variant} />
        <Visible xs sm>
          <Spacing spacing={1} />
        </Visible>
      </Col>
      <Col xs={12} md={11}>
        <StyledText
          translateKey={message}
          variant="body2"
          color={theme.colors.grey[100]}
        />
        {children}
      </Col>
    </StyledRow>
  );
};

export default Banner;
